import MuiLoading from '@mui/material/CircularProgress'

export default function Loading({ className, size, ...props }) {
  return (
    <div className={ cn('utils-progress-root flex items-center justify-center text-white', className) }>
      <MuiLoading size={ size || 24 }
        { ...props }
      />
    </div>
  )
}
